export namespace NHooks {
  export type UseServicesExport = {
    setLoader: (value: boolean) => void;
  };
}
